// extracted by mini-css-extract-plugin
export default {"labelContainer":"labels-module__labelContainer--F_y_s","labelLink":"labels-module__labelLink--H8Gx4"};